<button class="td-wb-confirm-button"
        tdWbButton
        tdWbButtonType="secondary"
        [tdWbModalClose]="value()">
  @if (label.innerText.trim() === '') {
    <span translate="tdWb.confirm.CANCEL"></span>
  }
  <span #label>
    <ng-content />
  </span>
</button>
